const appStoreURL = (import.meta.env.VITE_APP_STORE_URL as string | undefined)?.trim();

export function AppStoreCTA({ compact = false }: { compact?: boolean }) {
  const content = (
    <>
      <span className="app-store-cta__free">Free to play</span>
      <strong>{appStoreURL ? "Download on the App Store" : "App Store · Coming Soon"}</strong>
      <small>iPhone and iPad</small>
    </>
  );

  if (appStoreURL) {
    return <a className={`app-store-cta ${compact ? "is-compact" : ""}`} href={appStoreURL} rel="noreferrer">{content}</a>;
  }
  return <span className={`app-store-cta is-coming ${compact ? "is-compact" : ""}`} role="link" aria-disabled="true">{content}</span>;
}
